import React, { Component } from "react";
import * as actions from "../../../Store/Actions/index";
import { connect } from "react-redux";
import Checkbox from "../../CheckBox/CheckBox";
class FilterMenu extends Component {
  state = {
    allcheckbox: false,
    checkedItems: new Map(),
  };

  handleChange = (e, id, type, index) => {
    const item = e.target.name;
    var isChecked = e.target.checked;
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(item, isChecked),
    }));
    var textinputs =
      document.querySelectorAll("input:checked").length === 0
        ? "false"
        : "true";
    if (textinputs == "false") {
      this.props.callFilter(e, id, type, index);
      if (this.props.inputBookType === "allBooks") {
        this.props.getBooks();
      } else {
        this.props.getGoogleBooks();
      }
    } else {
      this.props.callFilter(e, id, type, index);
    }
  };
  clearAll = () => {
    this.setState({
      checkedItems: new Map(),
    });
    // this.props.callFilter(e, id, type, index);
    this.props.getBooks();
  };

  render() {
    switch (this.props.type) {
      case "grade":
        return (
          <div className="optionMenu">
            <div className="grade">
              <h6>
                Select Grade{" "}
                <i
                  onClick={() => this.props.toggleDropDown("grade")}
                  className="icon dripicons-chevron-down"
                ></i>
                {/* <span onClick={this.clearAll} className="clear">
                  clear
                </span> */}
              </h6>

              {this.props.state ? (
                <div className="gradeOption">
                  <ul>
                    {this.props.classList.map((gradeName, index) => {
                      return (
                        <li>
                          <label className="filterLabel">
                            <Checkbox
                              name={gradeName.class_name}
                              checked={this.state.checkedItems.get(
                                gradeName.class_name
                              )}
                              onChange={(e) => {
                                this.handleChange(
                                  e,
                                  gradeName.id,
                                  "class",
                                  index
                                );
                              }}
                            />
                            &nbsp;
                            {gradeName.class_name}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
        break;
      case "subject":
        return (
          <div className="optionMenu">
            <div className="grade">
              <h6>
                Select Subject{" "}
                <i
                  onClick={() => this.props.toggleDropDown("subject")}
                  className="icon dripicons-chevron-down"
                ></i>
                {/* <span onClick={this.clearAll} className="clear">
                  clear
                </span> */}
              </h6>

              {this.props.state ? (
                <div className="gradeOption">
                  <ul>
                    {this.props.subjectList.map((subjectName, index) => {
                      return (
                        <li>
                          <label className="filterLabel">
                            <Checkbox
                              id="class"
                              name={subjectName.subject_name}
                              checked={this.state.checkedItems.get(
                                subjectName.subject_name
                              )}
                              onChange={(e) => {
                                this.handleChange(
                                  e,
                                  subjectName.id,
                                  "subjects",
                                  index
                                );
                              }}
                            />
                            &nbsp;
                            {subjectName.subject_name}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
        break;
      case "board":
        return (
          <div className="optionMenu">
            <div className="grade">
              <h6>
                Select Board{" "}
                <i
                  onClick={() => this.props.toggleDropDown("board")}
                  className="icon dripicons-chevron-down"
                ></i>{" "}
                {/* <span onClick={this.clearAll} className="clear">
                  clear
                </span> */}
              </h6>

              {this.props.state ? (
                <div className="gradeOption">
                  <ul>
                    {this.props.boardList.map((boardName, index) => {
                      return (
                        <li>
                          <label className="filterLabel">
                            <Checkbox
                              id="class"
                              name={boardName.board_name}
                              checked={this.state.checkedItems.get(
                                boardName.board_name
                              )}
                              onChange={(e) => {
                                this.handleChange(
                                  e,
                                  boardName.id,
                                  "boards",
                                  index
                                );
                              }}
                            />
                            &nbsp;
                            {boardName.board_name}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      default:
        break;
    }
    return <div></div>;
  }
}

const mapStateToProps = (state) => {
  return {
    classList: state.filterMenu.gradeList,
    subjectList: state.filterMenu.subjectList,
    boardList: state.filterMenu.boardList,
    books: state.book.books,
    loading: state.book.loading,
    inputBookType: state.book.inputBookType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGrade: () => dispatch(actions.fetchGradeList()),
    getSubject: () => dispatch(actions.fetchSubjectsList()),
    getBoard: () => dispatch(actions.fetchBoardList()),
    getBooks: () => dispatch(actions.fetchBooks()),
    setFilter: (dataToBeFiltered) =>
      dispatch(actions.filterBooks(dataToBeFiltered)),
    getSelectedFilters: (filterData) =>
      dispatch(actions.getSelectedFilters(filterData)),
    getGoogleBooks: () => dispatch(actions.fetchGooglePlayBooks()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterMenu);
